// Performance (29 Oct 2026, merchant): pause every CSS animation inside page sections that are off screen
// (flap board shine, shimmer, marquee, scroll hints ...). Nothing changes visually: sections resume
// 200px before they scroll into view. CSS rule: [data-ma-off] in layout/theme.liquid.
if ('IntersectionObserver' in window) {
  const targets = document.querySelectorAll('main > *:not(s-lab-tabs):not(:has(s-lab-tabs)), body > footer, footer[role="contentinfo"], .ma-announce-top');
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) entry.target.toggleAttribute('data-ma-off', !entry.isIntersecting);
    },
    { rootMargin: '200px 0px' }
  );
  targets.forEach((el) => io.observe(el));
}
